import { useRudderstackAnonymousId } from '@ecomm/shared-window/lib/hooks/useRudderstackAnonymousId'
import { useRudderstackSessionId } from '@ecomm/shared-window/lib/hooks/useRudderstackSessionId'
import { useGoogleAnalytics } from '@ecomm/tracking/useGoogleAnalytics'
import { usePollVid } from '@ecomm/tracking/usePollVid'
import classNames from 'classnames'
import React, { useRef } from 'react'

import { embedJebbit } from './jebbitOnLoadScript'
import { createGSBLaunchUrlParams } from './lib'
import type { GuidedSystemBuilderSchema } from './schema'

export const GuidedSystemBuilder = React.memo(
  ({ type, jebbitUrl }: GuidedSystemBuilderSchema) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const vid = usePollVid()
    const [clientId, sessionId] = useGoogleAnalytics()
    const rudderstackSessionId = useRudderstackSessionId()
    const rudderstackAnonymousId = useRudderstackAnonymousId()

    const url =
      jebbitUrl ??
      'https://quiz.simplisafe.com/kaedkhe4?L=Full+Page&uid=&deferred=true'

    function renderGSB() {
      return (
        <div ref={containerRef}>
          <iframe
            allowFullScreen
            className={classNames(
              'jebbit-iframe min-h-[610px] w-full lg:h-fit'
            )}
            data-testid="jebbit-iframe"
            frameBorder="0"
            loading="lazy"
            onLoad={() => {
              embedJebbit('.jebbit-iframe')
            }}
            seamless={true}
            src={`${url}&${createGSBLaunchUrlParams(
              vid,
              clientId,
              sessionId,
              rudderstackSessionId,
              rudderstackAnonymousId,
              type
            )}`}
            title="Guided System Builder Quiz"
          />
        </div>
      )
    }

    return type === 'embedded' ? (
      <div
        className={classNames(
          'col-span-12 overflow-hidden rounded-2xl bg-white px-4'
        )}
      >
        {renderGSB()}
      </div>
    ) : (
      renderGSB()
    )
  }
)
